import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Avatar from '@material-ui/core/Avatar';
import InputAdornment from '@material-ui/core/InputAdornment';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/core/styles';

import avatar from '@material-ui/core/colors/amber';

import {
  startEditBid,
  startEditBidTask
} from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  left: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  right: {
    flexBasis: '175px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit*2,
    flexGrow: 1,
  },
  title: {
    marginRight: theme.spacing.unit*3,
  },
  description: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*3,
  },
  totalsRoot: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  },
  totals: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
  },
  optional: {
    width: '145px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
  },
});


const JobTaskHeader = (props) => {
  const {
    classes,
    bidTask,
    bidValidation,
    showValidation,
    preview,
    startEditBidTask,
    startEditBidEditorState
  } = props;

  const type = bidTask.type;

  return(
    <div className={classes.root}>
      <div className={classes.left}>
        <div className={classes.header}>
          <Avatar className={classes.avatar}>{type.substring(0,1).toUpperCase()}</Avatar>
          <TextField
            error={(showValidation && !!bidValidation.validateField(`title-${bidTask.id}`))}
            helperText={(showValidation && bidValidation.validateField(`title-${bidTask.id}`))}
            disabled={preview}
            id="title"
            label="Title"
            className={classNames(classes.textField, classes.title)}
            placeholder="Enter title"
            margin="normal"
            value={bidTask.title}
            onFocus={() => startEditBidEditorState("jobTasksTitle")}
            onChange={(event) => {
              const value = event.target.value;
              startEditBidTask(bidTask.id, {title: value})
            }}
          />
        </div>
        <TextField
                  disabled={preview}
                  id="description"
                  label="Description"
                  multiline
                  rows="6"
                  placeholder="Describe the task"
                  className={classNames(classes.textField, classes.description)}
                  margin="normal"
                  value={bidTask.description}
                  onFocus={() => startEditBidEditorState("jobTasksDescription")}
                  onChange={(event) => {
                    const value = event.target.value;
                    startEditBidTask(bidTask.id, {description: value})
                  }}
        />
      </div>
      <div className={classes.right}>
        <FormControlLabel
          className={classes.optional}
          control={
            <Switch
              disabled={preview}
              color="primary"
              checked={bidTask.optional}
              onFocus={() => startEditBidEditorState("jobTasksOptional")}
              onChange={() => {
                startEditBidTask(bidTask.id, {optional: !bidTask.optional})
              }}
            />
          }
          label={bidTask.optional === true ? "Optional" : "Required"}
        />
        {type==="estimate" &&
          <div className={classes.totals}>
            <TextField
              error={(showValidation && !!bidValidation.validateField(`estimate-${bidTask.id}`))}
              helperText={(showValidation && bidValidation.validateField(`estimate-${bidTask.id}`))}
              disabled={preview}
              id="estimateAmount"
              type="number"
              label="Estimate Amount"
              className={classes.textField}
              margin="normal"
              value={bidTask.estimate}
              onFocus={() => startEditBidEditorState("jobTasksEstimateAmount")}
              onChange={(event) => {
                const value = event.target.value;
                startEditBidTask(bidTask.id, {estimate: value})
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </div>
        }
        {type==="quote" &&
          <div className={classes.totals}>
            <div className={classes.labelField}>
              <Typography variant="subheading">Labor:</Typography>
              <Typography variant="subheading">${bidTask.laborTotal.toFixed(2)}</Typography>
            </div>
            <div className={classes.labelField}>
              <Typography variant="subheading">Materials:</Typography>
              <Typography variant="subheading">${bidTask.materialsTotal.toFixed(2)}</Typography>
            </div>
            <div className={classes.labelField}>
              <Typography variant="subheading">Subtotal:</Typography>
              <Typography variant="subheading">${bidTask.subtotal.toFixed(2)}</Typography>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { id: bidId, showValidation } = state.adminState.bid;
  const bid = state.bidsState.find( bid => bid.id === bidId )
  const bidValidation = state.validation.bids.find(item => item.id === bidId);

  return ({
    bid,
    bidValidation,
    showValidation,
  });
}

const mapDispatchToProps = (dispatch) => ({
  startEditBid: (bidId, bid) => dispatch(startEditBid(bidId, bid)),
  startEditBidTask: (bidTaskId, update) => dispatch(startEditBidTask(bidTaskId, update)),
  startEditBidEditorState: (key) => dispatch(startEditBidEditorState(key)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobTaskHeader);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/JobTaskHeader.jsx